import { type MutateOptions, useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { handleResponseThrowError } from '@/_utils/services';

interface PutFinishedByManagerParams {
  deliverymanId: string;
  deliveryId: string;
}

export const putFinishedByManager = async ({
  deliverymanId,
  deliveryId,
}: PutFinishedByManagerParams) => {
  return apiClient
    .put(`/jackson/${deliverymanId}/finished-by-manager`, {
      deliveryId,
    })
    .then(response => response.data)
    .catch(handleResponseThrowError('Não foi possível realizar a ação'));
};

export const usePutFinishedByManager = (
  options: Omit<
    MutateOptions<unknown, Error, PutFinishedByManagerParams>,
    'mutationFn'
  > = {},
) => {
  return useMutation({
    mutationFn: putFinishedByManager,
    ...options,
  });
};
